import React from 'react';

// Icona SVG user-plus, più visibile: bordo spesso, riempimento azzurro, simbolo + grande
export default function UserPlusIcon({ size = 28, color = '#1976d2', style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      {/* Testa */}
      <circle cx="12" cy="11" r="6" stroke={color} strokeWidth="2.5" fill="#e3f2fd" />
      {/* Corpo */}
      <path d="M20 28v-2c0-3.5-3-6.5-6-6.5h-4c-3 0-6 3-6 6.5v2" stroke={color} strokeWidth="2.5" fill="#e3f2fd" />
      {/* Più */}
      <rect x="23" y="14" width="10" height="3.2" rx="1.6" fill={color} />
      <rect x="27.4" y="9.5" width="3.2" height="10" rx="1.6" fill={color} />
    </svg>
  );
}
